export default __webpack_public_path__ + "static/media/inner-intelligent-quality.239a4de1.svg";